/**
 * 角度からラジアンに変換する
 *
 * 角度の指定が無い場合は0を返す。
 */
export var getRadianAngle = function (degrees) {
    if (degrees == null) {
        return 0;
    }
    return (degrees * Math.PI) / 180;
};
